
import React, { useState, useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { TimePickerDemo } from './TimePicker';

interface TimeSelectorProps {
  register: any;
  setValue: (name: string, value: any) => void;
  initialHour?: number;
  initialMinute?: number;
}

export const TimeSelector = ({ setValue, initialHour, initialMinute }: TimeSelectorProps) => {
  const getInitialTime = () => {
    if (initialHour !== undefined && initialHour !== null) {
      return `${initialHour.toString().padStart(2, '0')}:${(initialMinute || 0).toString().padStart(2, '0')}`;
    }
    return undefined;
  };

  const [time, setTime] = useState<string | undefined>(getInitialTime());

  const handleTimeChange = (value: string) => {
    setTime(value);
    
    // Extract hours and minutes from time string
    const [hours, minutes] = value.split(':').map(Number);
    
    // Set the values in the form
    setValue('scheduledHour', hours);
    setValue('scheduledMinute', minutes);
  };

  return (
    <div className="space-y-2">
      <Label>Select Time</Label>
      <TimePickerDemo value={time} onChange={handleTimeChange} />
    </div>
  );
};
